import React from "react";
import { FaExternalLinkAlt, FaLaptopCode } from "react-icons/fa";

const GreenOJSection = () => {
  return (
    <section className="home-section border-none pt-0">
      <div className="home-container">
        <article className="home-card-strong p-7 sm:p-10">
          <div className="mb-3 inline-flex items-center gap-2 text-sm font-semibold home-accent">
            <FaLaptopCode /> Our Online Judge
          </div>

          <h2 className="home-title text-2xl font-bold sm:text-4xl">
            Meet <span className="home-accent-gradient">GreenOJ</span>
          </h2>

          <p className="mt-4 max-w-4xl text-sm leading-7 home-muted sm:text-base">
            GreenOJ is our own online judge platform built for continuous problem-solving practice, contest participation, and performance tracking.
            It helps members train with real submissions, sharpen algorithmic thinking, and stay consistent throughout the learning journey.
          </p>

          <a
            href="https://greenoj.bd"
            target="_blank"
            rel="noreferrer"
            className="home-btn-primary mt-6 inline-flex items-center gap-2 px-5 py-3 text-sm font-semibold"
          >
            Visit GreenOJ <FaExternalLinkAlt className="text-xs" />
          </a>
        </article>
      </div>
    </section>
  );
};

export default GreenOJSection;
